import {render} from 'preact';
import {useState} from 'preact/hooks';
import App from './editor/AppHome';
import './app.css';

function ConnectionCheck() {
  const [status, setStatus] = useState('Ready to verify Shopify access.');
  const [busy, setBusy] = useState(false);
  async function verify() {
    setBusy(true);
    try {
      const response = await fetch('shopify:admin/api/2026-07/graphql.json', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({query: '{ shop { name myshopifyDomain } }'}),
      });
      const result = await response.json();
      if (!response.ok || result.errors?.length) throw new Error(result.errors?.[0]?.message || 'Shopify request failed.');
      setStatus(`Connected to ${result.data.shop.name} (${result.data.shop.myshopifyDomain}).`);
    } catch (error) { setStatus(error instanceof Error ? error.message : 'Unable to connect to Shopify.'); }
    finally { setBusy(false); }
  }
  return <s-page heading="EVP Configurator">
    <s-section heading="Hosted editor connection check">
      <s-stack gap="base">
        <s-paragraph>{status}</s-paragraph>
        <s-button onClick={verify} disabled={busy}>Verify Shopify connection</s-button>
        <s-button onClick={() => window.shopify.resourcePicker({type: 'product', multiple: false})}>Test product picker</s-button>
      </s-stack>
    </s-section>
  </s-page>;
}

const embedded = window.self !== window.top;
async function start() {
  if (__STANDALONE__) {
    const {installStandalone} = await import('./standalone');
    installStandalone();
  }
  render((embedded || __STANDALONE__) ? (window.location.pathname === '/connection-check' && !__STANDALONE__ ? <ConnectionCheck /> : <App />) : <main><h1>EVP Configurator</h1><p>Open this app from Shopify admin to access store data.</p></main>, document.getElementById('app'));
}
start();
